var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"floating",staticClass:"floating-repair-select-wrapper",class:{ 'is-dragging': _vm.isDragging },style:(_vm.wrapperStyle),on:{"pointerdown":_vm.startDrag,"click":_vm.handleClick}},[_c('div',{staticClass:"tooltip",class:{
      'tooltip--below': _vm.isTooltipBelow,
      'tooltip--left': _vm.isTooltipLeft,
    }},[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")]),_c('button',{staticClass:"floating-repair-select-button",on:{"dragstart":function($event){$event.preventDefault();}}},[_c('img',{attrs:{"src":"/img/icons/rs_icon.png","alt":"Repair Select","draggable":"false"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }